export default __webpack_public_path__ + "static/media/JazzMusicPortal.a1bef473.gif";